import keyMirror from 'keymirror';

export const testResultsActionTypes = keyMirror({
	GET_ANSWERS: null,
	GET_ANSWERS_SUCCESS: null,
	GET_RESULTS_DETAILS: null,
	GET_RESULTS_DETAILS_SUCCESS: null,

	GET_RESULTS: null,
	GET_RESULTS_SUCCESS: null,
	GET_RESULTS_ERROR: null,

	GET_TOPIC_ANSWERS: null,
	GET_TOPIC_ANSWERS_SUCCESS: null,
	GET_TOPIC_ANSWERS_ERROR: null,

	CLEAR_TEST_RESULTS: null,
});

export const HIGHEST_POSSIBLE_GRADE = 10;

export const getTestResultTabs = (t) => [
	{ title: t('test_results.tabs.answers'), value: 'answers', index: 0, link: 'answers' },
	{ title: t('test_results.tabs.results'), value: 'results', index: 1, link: 'results' },
];

export const getRegularTestHeaderDesc = (t, isPracticeSet) => ({
	1: {
		title: t('test_results.regular_test_header_desc.1.title'),
		description: t('test_results.regular_test_header_desc.1.description', {
			context: isPracticeSet ? 'practice_set' : '',
		}),
		percentage_limit: 44,
	},
	2: {
		title: t('test_results.regular_test_header_desc.2.title'),
		description: t('test_results.regular_test_header_desc.2.description', {
			context: isPracticeSet ? 'practice_set' : '',
		}),
		percentage_limit: 54,
	},
	3: {
		title: t('test_results.regular_test_header_desc.3.title'),
		description: t('test_results.regular_test_header_desc.3.description', {
			context: isPracticeSet ? 'practice_set' : '',
		}),
		percentage_limit: 64,
	},
	4: {
		title: t('test_results.regular_test_header_desc.4.title'),
		description: t('test_results.regular_test_header_desc.4.description', {
			context: isPracticeSet ? 'practice_set' : '',
		}),
		percentage_limit: 74,
	},
	5: {
		title: t('test_results.regular_test_header_desc.5.title'),
		description: t('test_results.regular_test_header_desc.5.description', {
			context: isPracticeSet ? 'practice_set' : '',
		}),
		percentage_limit: 84,
	},
	6: {
		title: t('test_results.regular_test_header_desc.6.title'),
		description: t('test_results.regular_test_header_desc.6.description', {
			context: isPracticeSet ? 'practice_set' : '',
		}),
		percentage_limit: 94,
	},
	7: {
		title: t('test_results.regular_test_header_desc.7.title'),
		description: t('test_results.regular_test_header_desc.7.description', {
			context: isPracticeSet ? 'practice_set' : '',
		}),
		percentage_limit: 99,
	},
	8: {
		title: t('test_results.regular_test_header_desc.8.title'),
		description: t('test_results.regular_test_header_desc.8.description', {
			context: isPracticeSet ? 'practice_set' : '',
		}),
	},
});

export const getDiagnosticTestHeaderDesc = (t, context) => ({
	1: {
		title: t('test_results.diagnostic_test_header_desc.1.title'),
		description: t('test_results.diagnostic_test_header_desc.1.description'),
		percentage_limit: 40,
	},
	2: {
		title: t('test_results.diagnostic_test_header_desc.2.title'),
		description: t('test_results.diagnostic_test_header_desc.2.description'),
		percentage_limit: 80,
	},
	3: {
		title: t('test_results.diagnostic_test_header_desc.3.title'),
		description: t('test_results.diagnostic_test_header_desc.3.description'),
		percentage_limit: 100,
	},
	4: {
		title: t('test_results.diagnostic_test_header_desc.4.title'),
		description: t('test_results.diagnostic_test_header_desc.4.description'),
	},
	5: {
		title: t('test_results.diagnostic_test_header_desc.5.title'),
		description: t('test_results.diagnostic_test_header_desc.5.description'),
		percentage_limit: 20,
	},
	6: {
		title: t('test_results.diagnostic_test_header_desc.6.title'),
		description: t('test_results.diagnostic_test_header_desc.6.description'),
		percentage_limit: 60,
	},
	7: {
		title: t('test_results.diagnostic_test_header_desc.7.title'),
		description: t('test_results.diagnostic_test_header_desc.7.description'),
		percentage_limit: 80,
	},
	8: {
		title: t('test_results.diagnostic_test_header_desc.8.title'),
		description: t('test_results.diagnostic_test_header_desc.8.description', { context }),
	},
});

export const ONE_HOUR_IN_MILLISECONDS = 60 * 60 * 1000;
